import { Link } from "react-router-dom";
import { Hero, TrustStrip, HowItWorksSteps } from "@/components/site/Hero";
import { WhyChoose, StorySection, DeliveryAreasSection, Testimonials, FinalCTA } from "@/components/site/HomeSections";
import { PlansGrid } from "@/components/site/PlanCard";
import { FAQList } from "@/components/site/FAQList";
import { Section, SectionHeading, Seo, Reveal } from "@/components/site/Section";
import { FAQS } from "@/data/faqs";
import { KingsmossSection } from "@/components/site/Kingsmoss";

export default function Home() {
  return (
    <>
      <Seo path="/" description="Monthly firewood subscriptions in Newtownabbey and the BT36–BT39 area. Kiln-dried logs, kindling and firelighters delivered to your door every month, from £34.99." />
      <Hero />
      <TrustStrip />
      <HowItWorksSteps />
      <Section id="plans" className="bg-[#0b0b0b]" data-testid="home-plans-section">
        <SectionHeading eyebrow="Subscription plans" title="Choose the plan that fits your fire." intro="Simple monthly plans. Kindling and firelighters included. Change or cancel online whenever you like. Need something different? Ask us about a custom plan." />
        <div className="mt-14"><PlansGrid /></div>
      </Section>
      <WhyChoose />
      <StorySection />
      <DeliveryAreasSection />
      <Section data-testid="home-faq-section">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading eyebrow="FAQs" title="Frequently asked questions." />
            <Reveal delay={0.1}>
              <Link to="/faqs" className="mt-8 inline-flex lc-btn-ghost" data-testid="home-all-faqs">See all FAQs</Link>
            </Reveal>
          </div>
          <div className="lg:col-span-8"><FAQList items={FAQS.filter((_, i) => [0, 2, 3, 5, 8, 9].includes(i))} prefix="home-faq" /></div>
        </div>
      </Section>
      <Testimonials />
      <FinalCTA />
      <KingsmossSection />
    </>
  );
}
